module.exports = __webpack_public_path__ + "components/weather-icon/static/nightsnowshowers-39fdd245bdc24689c34c66eef5a64234.svg";